import { render, staticRenderFns } from "./Scene5.vue?vue&type=template&id=4d993e48&scoped=true"
import script from "./Scene5.vue?vue&type=script&lang=js"
export * from "./Scene5.vue?vue&type=script&lang=js"
import style0 from "./Scene5.vue?vue&type=style&index=0&id=4d993e48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d993e48",
  null
  
)

export default component.exports